import http from '@/api/http';
import type { ShippingDirection } from '@/contexts/DirectionContext';
import type { ExtendedStatistics } from '../interfaces/extendedStatistics.interface';

export const extendedStatisticsApi = {
  async get(companyId?: number, direction?: ShippingDirection): Promise<ExtendedStatistics> {
    const params: Record<string, string | number> = {};
    if (typeof companyId === 'number') params.companyId = companyId;
    if (direction) params.direction = direction;
    const response = await http.get('/dashboard/extended-statistics', { params });
    return response.data?.data as ExtendedStatistics;
  },
};
